import { observer } from 'mobx-react-lite'

import type UpdateController from '@src/updater/UpdateController'

import { UpdateContext } from '@odyssey/contexts/UpdateContext/UpdateContext'

function UpdateContextBridgeProvider({
  updateController,
  children,
}: {
  updateController: UpdateController
  children: React.ReactNode
}) {
  const updateReady = updateController.updateReady

  return (
    <UpdateContext.Provider
      value={{
        updateReady,
        isUpdateAvailable: () => updateController.isUpdateAvailable(),
        installAndRestart: () => updateController.installAndRestart(),
      }}
    >
      {children}
    </UpdateContext.Provider>
  )
}

export default observer(UpdateContextBridgeProvider)
